require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./social-media-calendar-template-thank-you-for-downloading.json") })
        }
      }, "path---social-media-calendar-template-thank-you-for-downloading");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---social-media-calendar-template-thank-you-for-downloading!./.cache/json/social-media-calendar-template-thank-you-for-downloading.json
// module id = 783
// module chunks = 231608221292675